/**
 *Styles
 */
import "./ButtonGroup.scss";

const ButtonGroup = ({ step, setStep, cbStepSkip, cbStepNext }) => {
  const handlerNextStep = (buttonType) => {
    if (setStep) {
      setStep(step + 1);
    }
    if (buttonType === "skip" && cbStepSkip) {
      cbStepSkip();
    }
    if (buttonType === "next" && cbStepNext) {
      cbStepNext();
    }
  };

  return (
    <div className="button__wrapper">
      <button onClick={() => handlerNextStep("skip")} className="skip">
        <span>Skip</span>
      </button>
      <button onClick={() => handlerNextStep("next")} className="next">
        <span>Yes</span>
      </button>
    </div>
  );
};
export default ButtonGroup;
